import CaseStudiesPreview from "../../../Components/CaseStudiesPreview/CaseStudiesPreview";
import ApproachSection from "./ApproachSection";
import IntroductionSection from "./IntroductionSection";
import StrengthSection from "./StrengthSection";
import ContactSection from "./ContactSection";
import GVImage from "../../../assets/images/case-studies/thumb/GV.png";
import EYSImage from "../../../assets/images/case-studies/thumb/EYS.png";
import CSImage from "../../../assets/images/case-studies/thumb/CS.png";

const caseStudies = [
  {
    title: "Golden Village",
    description:
      "Expanding The Cinema Experience To A Wider Audience",
    hint: "API Development, Systems integration",
    path: "/case-studies/golden-village",
    image: GVImage,
  },
  {
    title: "Eu Yan Sang",
    description:
      "Turning The Digitalisation Of A 140 Year Old Business Into An Opportunity For Innovation.",
    hint: "E-commerce, Android, iOS Mobile App",
    path: "/case-studies/eu-yan-sang",
    image: EYSImage,
  },
  {
    title: "Chiropractic Singapore",
    description:
      "Enhancing Patient Experience: Chiropractic Singapore's Integrated Queue Management System",
    hint: "Queue Managment System, UI/UX, Systems integration",
    path: "/case-studies/chiropractic-singapore",
    image: CSImage,
  },
];

export default function SoftwareIntegration() {
  return (
    <>
      <IntroductionSection />
      <StrengthSection />
      <ApproachSection />
      <CaseStudiesPreview caseStudies={caseStudies} />
      <ContactSection />
    </>
  );
}
